import { render, staticRenderFns } from "./r-item-kind-dialog.vue?vue&type=template&id=7c35511e&scoped=true"
import script from "./r-item-kind-dialog.vue?vue&type=script&lang=js"
export * from "./r-item-kind-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-item-kind-dialog.vue?vue&type=style&index=0&id=7c35511e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c35511e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c35511e')) {
      api.createRecord('7c35511e', component.options)
    } else {
      api.reload('7c35511e', component.options)
    }
    module.hot.accept("./r-item-kind-dialog.vue?vue&type=template&id=7c35511e&scoped=true", function () {
      api.rerender('7c35511e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item-kind/r-item-kind-dialog.vue"
export default component.exports